
export default {
    
    debug(data) {
        let is_debug = false
        
        if (is_debug) {
            console.log(data)
        }
        
    }
}